"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[9198],{

/***/ 80348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export keyToIconNameMap */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24959);




const keyToIconNameMap = {
    "BESTSELLER": "48/bestseller",
    "CHARITY": "48/charity",
    "CLEAN": "48/clean",
    "LIMITED_EDITION": "48/limited-time",
    "NEW_ARRIVAL": "48/new",
    "SOLD_OUT": "48/out-of-stock"
};
const ProductGraphicLabels = (props)=>{
    let { className, items, limit } = props;
    if (!items?.length) {
        return null;
    }
    if (limit && items.length > limit) {
        items = items.slice(0, limit);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "grid grid-cols-1 gap-16"),
        children: items.map((key)=>Boolean(keyToIconNameMap[key]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                className: "mx-auto",
                name: keyToIconNameMap[key],
                "aria-label": key
            }, key))
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ProductGraphicLabels));


/***/ }),

/***/ 82775:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductPrice_ProductPrice)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/ProductPrice/messages.ts
/* harmony default export */ const messages = ({
    old: {
        en: "Price reduced from"
    },
    new: {
        en: "On sale at"
    }
});

;// CONCATENATED MODULE: ./src/compositions/ProductPrice/ProductPrice.tsx







// TODO should we use currencyCode from data? - added on 14.01.2022 by sonatskiy
const ProductPrice = (props)=>{
    const { className, data, formattedData, textStyle = "h8", oldPriceClassName = "font-normal", newPriceClassName = "font-bold", withNbsp = true } = props;
    const intl = (0,useIntl/* default */.Z)();
    const discountPrice = data?.discountPrice?.amount;
    const standardPrice = data?.standardPrice?.amount;
    let finalPrice;
    let oldPrice;
    let oldPriceLabel;
    let newPriceLabel;
    if (formattedData) {
        const { discountPrice, standardPrice } = formattedData;
        finalPrice = discountPrice || standardPrice;
        if (finalPrice !== standardPrice) {
            oldPrice = standardPrice;
            oldPriceLabel = intl.formatMessage(messages.old);
            newPriceLabel = intl.formatMessage(messages.new);
        }
    } else {
        if (typeof discountPrice === "number") {
            // it's formatted as USD, not cents
            finalPrice = (0,formatPrice/* default */.Z)(discountPrice, {
                isCents: false
            });
            if (standardPrice > discountPrice) {
                oldPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                    isCents: false
                });
                oldPriceLabel = intl.formatMessage(messages.old);
                newPriceLabel = intl.formatMessage(messages.new);
            }
        } else if (typeof standardPrice === "number") {
            finalPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                isCents: false
            });
        }
    }
    if (!finalPrice) {
        return null;
    }
    if (oldPrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
            className: className,
            style: textStyle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                    className: (0,clsx/* default */.Z)(oldPriceClassName),
                    "aria-label": oldPriceLabel,
                    "data-testid": "oldPrice",
                    children: oldPrice
                }),
                withNbsp && "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    className: (0,clsx/* default */.Z)(newPriceClassName),
                    "aria-label": newPriceLabel,
                    "data-testid": "price",
                    children: finalPrice
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: (0,clsx/* default */.Z)(className, newPriceClassName),
        style: textStyle,
        "data-testid": "price",
        children: finalPrice
    });
};
/* harmony default export */ const ProductPrice_ProductPrice = (/*#__PURE__*/react.memo(ProductPrice));


/***/ }),

/***/ 33297:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ResubscribeWithTimerStickyBar_ResubscribeWithTimerStickyBar)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useStickyBeforeFooter.ts
var useStickyBeforeFooter = __webpack_require__(29555);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/modules/subscription/resubscribe/useResubscribeOffer.tsx
var useResubscribeOffer = __webpack_require__(16776);
// EXTERNAL MODULE: ./src/modules/subscription/prices/index.ts + 1 modules
var prices = __webpack_require__(81223);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/components/layout/StickyFooterContainer/StickyFooterContainer.tsx + 1 modules
var StickyFooterContainer = __webpack_require__(53046);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/compositions/StyledTimer/StyledTimer.tsx + 1 modules
var StyledTimer = __webpack_require__(93735);
// EXTERNAL MODULE: ./src/compositions/buttons/ResubscribeButton/ResubscribeButton.tsx
var ResubscribeButton = __webpack_require__(53197);
;// CONCATENATED MODULE: ./src/compositions/ResubscribeWithTimerStickyBar/messages.ts
/* harmony default export */ const ResubscribeWithTimerStickyBar_messages = ({
    noDiscount: {
        en: "Resubscribe today to access our catalog of over 700 scents."
    },
    discount: {
        en: "Resubscribe and get your next month for {priceWithDiscount}."
    },
    percentOff: {
        en: "Take {eventOffer} your first month back<br/>when you resubscribe."
    },
    freeProduct: {
        en: "Resubscribe and get a FREE fragrance<br/>in your next order."
    },
    freeCase: {
        en: "Resubscribe and get a FREE case<br/>in your next order."
    },
    freeMonth: {
        en: "Resubscribe today, and your<br/>next month is FREE."
    },
    resubscribeForPrice: {
        en: "resubscribe for {priceWithDiscount} <s>{price}</s>"
    }
});

;// CONCATENATED MODULE: ./src/compositions/ResubscribeWithTimerStickyBar/ResubscribeWithTimerStickyBar.tsx












const ResubscribeWithTimerStickyBar = (props)=>{
    const { containerSize = 944, position = "top", isReverseMobile, minimalScrollOffset, triggerRef } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const isVisible = (0,useStickyBeforeFooter/* default */.Z)({
        triggerRef,
        minimalScrollOffset
    });
    const { offer, couponCode, isFetching: isCouponDataFetching, eventOffer } = (0,useResubscribeOffer/* useResubscribeOffer */.W)();
    const { formattedPriceWithDiscount: priceWithDiscount, formattedPrice: price, isFetching: isPricesFetching } = (0,prices/* usePrices */.h)({
        couponCode,
        skip: isCouponDataFetching
    });
    const isFetching = isCouponDataFetching || isPricesFetching;
    const { text, buttonTitle } = (0,react.useMemo)(()=>{
        if (isFetching) {
            return {};
        }
        let text;
        if (offer.startsWith("off")) {
            text = ResubscribeWithTimerStickyBar_messages.percentOff;
        } else {
            text = ResubscribeWithTimerStickyBar_messages[offer];
        }
        const shouldShowPriceWithDiscount = Boolean(priceWithDiscount && priceWithDiscount !== price && (offer.startsWith("off") || offer === "discount"));
        const buttonTitleBase = shouldShowPriceWithDiscount ? ResubscribeWithTimerStickyBar_messages.resubscribeForPrice : messages/* default */.Z.resubscribe;
        const buttonTitle = {
            ...buttonTitleBase,
            values: {
                price,
                priceWithDiscount
            }
        };
        return {
            text,
            buttonTitle
        };
    }, [
        isFetching,
        offer,
        price,
        priceWithDiscount
    ]);
    if (isFetching) {
        return null;
    }
    const mobileContainerClassName = isReverseMobile ? "pb-16 flex flex-col" : "pt-16";
    const mobileButtonClassName = isReverseMobile ? "order-2" : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyFooterContainer/* default */.Z, {
        bgColor: "bg-red",
        position: position,
        isVisible: isVisible,
        "data-testid": "stickyFooter",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: (0,clsx/* default */.Z)(isMobile ? mobileContainerClassName : "flex items-center justify-between"),
            size: containerSize,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResubscribeButton/* default */.Z, {
                    className: (0,clsx/* default */.Z)(isMobile ? mobileButtonClassName : "order-2 my-24 ml-32"),
                    title: buttonTitle,
                    size: 56,
                    width: 280,
                    fullWidthOnMobile: true,
                    placement: "Sticky bar"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-1 items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: !isMobile && "bold",
                                message: {
                                    ...text,
                                    values: {
                                        priceWithDiscount,
                                        eventOffer
                                    }
                                },
                                style: isMobile ? "p4" : "sh4",
                                color: "white",
                                html: true
                            })
                        }),
                        offer !== "noDiscount" && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimer/* default */.Z, {
                            className: isMobile ? "ml-16 mt-8" : "ml-20 mt-12",
                            size: isMobile ? 36 : 56,
                            captionColor: "white",
                            "data-testid": "timer"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const ResubscribeWithTimerStickyBar_ResubscribeWithTimerStickyBar = (ResubscribeWithTimerStickyBar);


/***/ }),

/***/ 50346:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ScentbirdSelectBlock_ScentbirdSelectBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/components/dataDisplay/HeroMediaBlock/HeroMediaBlock.tsx + 1 modules
var HeroMediaBlock = __webpack_require__(68155);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/HeroSection/images/hero-image-desktop.jpg
const hero_image_desktop_namespaceObject = __webpack_require__.p + "images/hero-image-desktop_196c47.jpg";
;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/HeroSection/images/hero-male-desktop.jpg
const hero_male_desktop_namespaceObject = __webpack_require__.p + "images/hero-male-desktop_168f97.jpg";
;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/HeroSection/images/hero-image-mobile.jpg
const hero_image_mobile_namespaceObject = __webpack_require__.p + "images/hero-image-mobile_081914.jpg";
;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/HeroSection/images/scentbird-select-logo.png
const scentbird_select_logo_namespaceObject = __webpack_require__.p + "images/scentbird-select-logo_206048.png";
;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/HeroSection/images/scentbird-select-logo.png?src-loader

/* harmony default export */ const scentbird_select_logosrc_loader = ({ src: scentbird_select_logo_namespaceObject, aspect: 4.305882352941176 });
;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/HeroSection/messages.ts
/* harmony default export */ const messages = ({
    description: {
        en: `
    Discover our curated collection of premium perfumes and colognes from the most <br class="onlyDesktop" />
    exclusive fragrance houses, hand-picked by our team of scent experts.
  `
    }
});

;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/HeroSection/HeroSection.tsx













const HERO_IMAGE_HEIGHT_DESKTOP = 460;
const HERO_IMAGE_HEIGHT_MOBILE = 300;
const HeroSection = (props)=>{
    const { title, description } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { gender } = (0,user/* useUser */.aF)();
    const isMale = gender === "MALE";
    const heroImageDesktop = isMale ? hero_male_desktop_namespaceObject : hero_image_desktop_namespaceObject;
    const heroImageMobile = isMale ? hero_male_desktop_namespaceObject : hero_image_mobile_namespaceObject;
    const withTitle = Boolean(title);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z.Image, {
                    src: isMobile ? heroImageMobile : heroImageDesktop,
                    height: isMobile ? HERO_IMAGE_HEIGHT_MOBILE : HERO_IMAGE_HEIGHT_DESKTOP
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
                className: "-mt-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)("bg-black-100 text-center text-white", isMobile ? "px-16 pb-24" : "pb-32"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            className: isMobile ? "mt-32 w-[294rem]" : "mt-32 w-[366rem]",
                            src: scentbird_select_logosrc_loader.src,
                            aspect: scentbird_select_logosrc_loader.aspect
                        }),
                        withTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: isMobile ? "my-16" : "my-24",
                            message: title,
                            style: "h5",
                            color: "gold-30",
                            html: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: !withTitle && "mt-24",
                            message: description || messages.description,
                            style: isMobile ? "p3" : "p2",
                            html: true
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ const HeroSection_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./local_modules/intersection-observer/useEntry.ts
var useEntry = __webpack_require__(99214);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/modules/collaborations/useCollaborationProducts.ts
var useCollaborationProducts = __webpack_require__(28724);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/compositions/productLists/ProductCarousel/ProductCarousel.tsx + 1 modules
var ProductCarousel = __webpack_require__(63316);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/inputs/RoundButton/RoundButton.tsx
var RoundButton = __webpack_require__(84700);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var Button_messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/ProductsSection/components/ViewMoreButton/ViewMoreButton.tsx





const ViewMoreButton = (param)=>{
    let { to } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col items-center justify-center px-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Href/* default */.Z, {
            className: "text-center",
            to: to,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundButton/* default */.Z, {
                    className: "bg-black-100",
                    title: Button_messages/* default */.Z.viewAll,
                    size: 32,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "32/arrow-right",
                        color: "white"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-16 whitespace-nowrap",
                    message: Button_messages/* default */.Z.viewAll,
                    style: "t4"
                })
            ]
        })
    });
};
/* harmony default export */ const ViewMoreButton_ViewMoreButton = (ViewMoreButton);

;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/ProductsSection/messages.ts
/* harmony default export */ const ProductsSection_messages = ({
    browse: {
        en: "Browse Scentbird select"
    },
    browseSaks: {
        en: "Browse Saks select"
    }
});

;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/components/ProductsSection/ProductsSection.tsx













const PRODUCTS_LIMIT = 6;
const ProductsSection = (props)=>{
    const { excludeId, metadata, type = "detailed", withBrowseButton = true, withNonAuthRedirect, withoutLink, onProductButtonClick } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const [ref, entry] = (0,useEntry/* default */.Z)({
        once: true,
        observerProps: {
            rootMargin: "50%"
        }
    });
    const skip = !entry?.isIntersecting;
    const { data, isFetching } = (0,useCollaborationProducts/* default */.Z)({
        catalogueType: "all",
        collaboration: "saks",
        excludeId,
        limit: PRODUCTS_LIMIT,
        productsFeed: "SAKS_SELECTED",
        skip
    });
    const link = links/* default */.ZP.scentbirdSelect;
    const extraNode = isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreButton_ViewMoreButton, {
        to: link
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        ref: ref,
        className: isMobile ? "mt-24 pb-24" : "mt-32 pb-40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel/* default */.Z, {
                desktopType: type,
                products: data,
                isFetching: isFetching,
                extraNode: extraNode,
                metadata: metadata,
                withNonAuthRedirect: withNonAuthRedirect,
                withoutLink: withoutLink,
                onProductButtonClick: (data)=>{
                    (0,analytics/* track */.j)("Banner click", {
                        action: "Add to queue",
                        content: "Scentbird select",
                        placement: "Page body",
                        productId: data.id,
                        productGender: data.gender,
                        productFullName: data.fullName,
                        productBrand: data.brandInfo.name,
                        productCategory: data.category,
                        productVolume: "0.27 oz, 50 ml"
                    });
                    if (typeof onProductButtonClick === "function") {
                        onProductButtonClick();
                    }
                }
            }),
            withBrowseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("text-center", isMobile ? "mt-24" : "mt-32"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: ProductsSection_messages.browse,
                    to: link,
                    style: "primary",
                    fullWidthOnMobile: true,
                    size: 56,
                    width: 320,
                    onClick: ()=>{
                        (0,analytics/* track */.j)("Banner click", {
                            link,
                            action: "link",
                            content: "Scentbird select",
                            placement: "Page body"
                        });
                    },
                    "data-testid": "scentbirdSelectBlockActionButton"
                })
            })
        ]
    });
};
/* harmony default export */ const ProductsSection_ProductsSection = (ProductsSection);

;// CONCATENATED MODULE: ./src/compositions/ScentbirdSelectBlock/ScentbirdSelectBlock.tsx







const ScentbirdSelectBlock = (props)=>{
    const { className, excludeId, metadata = {}, title, description, productsCarouselType, withBrowseButton, withNonAuthRedirect, withoutLink, onProductButtonClick } = props;
    const isEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.collaborationSaks);
    const mergedMetadata = (0,react.useMemo)(()=>{
        return {
            placement: "Scentbird select block",
            ...metadata
        };
    }, [
        metadata
    ]);
    if (!isEnabled) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "bg-[#eedfd3]"),
        "data-testid": "scentbirdSelectBlock",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection_HeroSection, {
                title: title,
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSection_ProductsSection, {
                excludeId: excludeId,
                metadata: mergedMetadata,
                type: productsCarouselType,
                withBrowseButton: withBrowseButton,
                withNonAuthRedirect: withNonAuthRedirect,
                withoutLink: withoutLink,
                onProductButtonClick: onProductButtonClick
            })
        ]
    });
};
/* harmony default export */ const ScentbirdSelectBlock_ScentbirdSelectBlock = (ScentbirdSelectBlock);


/***/ }),

/***/ 93735:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ StyledTimer_StyledTimer)
});

// UNUSED EXPORTS: bgColorToClassName

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(53743);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/StyledTimer/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Deal ends in:"
    },
    time: {
        en: "{time}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/StyledTimer/StyledTimer.tsx
/* eslint-disable max-len */ 







const bgColorToClassName = {
    "black": "bg-black",
    "white": "bg-white",
    "gray-10": "bg-gray-10",
    "light-beige": "bg-light-beige",
    "gold-30": "bg-gold-30",
    "gold-70": "bg-gold-70"
};
const baseBoxClassName = "flex items-center justify-center rounded";
const getParamsBySize = (param)=>{
    let { size, countdownColor, captionColor, backgroundColor, withHours } = param;
    const backgroundColorClass = backgroundColor ? `bg-${backgroundColor}` : "bg-light-beige";
    const countdownColorClass = countdownColor ? `text-${countdownColor}` : "";
    const captionColorClass = captionColor ? `text-${captionColor}` : "";
    const className = (0,clsx/* default */.Z)(baseBoxClassName, backgroundColorClass, countdownColorClass);
    if (size === 24) {
        return {
            textStyle: "text-sh6 text-[12rem]",
            format: `
        ${withHours ? `[<div class="mr-8"><div class="w-s24 h-s24 ${className}">] HH [</div><div class="${captionColorClass} text-t8">hours</div></div><div class="${captionColorClass}">:</div>]` : ""}
        [<div class="mr-8 ${withHours ? "ml-8" : ""}"><div class="w-s24 h-s24 ${className}">] mm [</div><div class="${captionColorClass} text-t8">minutes</div></div><div class="${captionColorClass}">:</div>]
        [<div class="ml-8"><div class="w-s24 h-s24 ${className}">] ss [</div><div class="${captionColorClass} text-t8">seconds</div></div>]
      `
        };
    }
    if (size === 36) {
        return {
            textStyle: "text-sh6",
            format: `
        ${withHours ? `[<div class="mr-8"><div class="w-s36 h-s36 ${className}">] HH [</div><div class="${captionColorClass} text-t3">hours</div></div><div class="${captionColorClass}">:</div>]` : ""}
        [<div class="mr-8 ${withHours ? "ml-8" : ""}"><div class="w-s36 h-s36 ${className}">] mm [</div><div class="${captionColorClass} text-t3">minutes</div></div><div class="${captionColorClass}">:</div>]
        [<div class="ml-8"><div class="w-s36 h-s36 ${className}">] ss [</div><div class="${captionColorClass} text-t3">seconds</div></div>]
      `
        };
    }
    if (size === 56) {
        return {
            textStyle: "text-sh3",
            format: `
        ${withHours ? `[<div class="mr-8"><div class="w-s56 h-s56 ${className}">] HH [</div><div class="mt-4 ${captionColorClass} text-p5">hours</div></div><div class="${captionColorClass}">:</div>]` : ""}
        [<div class="mr-8 ${withHours ? "ml-8" : ""}"><div class="w-s56 h-s56 ${className}">] mm [</div><div class="mt-4 ${captionColorClass} text-p5">minutes</div></div><div class="${captionColorClass}">:</div>]
        [<div class="ml-8"><div class="w-s56 h-s56 ${className}">] ss [</div><div class="mt-4 ${captionColorClass} text-p5">seconds</div></div>]
      `
        };
    }
};
const StyledTimer = (props)=>{
    const { className, initialTime, backgroundColor, countdownColor, captionColor, titleClassname: customTitleClassname, titleColor: customTitleColor, titleStyle: customTitleStyle, withHours, withTitle, size = 56, cookieName = constants/* default */.Z.cookieNames.rootCountdown, showExpiredTimer, "data-testid": dataTestId, onExpired } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const countdownRef = (0,react.useRef)();
    const { format, textStyle } = getParamsBySize({
        size,
        countdownColor,
        captionColor,
        backgroundColor,
        withHours
    });
    const { countdownMessage, isExpired } = (0,useCountdown/* default */.Z)({
        nodeRef: countdownRef,
        cookieName,
        initialTime,
        format,
        message: messages.time
    });
    (0,react.useEffect)(()=>{
        if (isExpired && typeof onExpired === "function") {
            onExpired();
        }
    }, [
        isExpired,
        onExpired
    ]);
    const titleClassname = isMobile ? "mb-12" : "mb-24";
    const titleColor = isMobile ? "white" : "gold-70";
    const titleStyle = isMobile ? "t1" : "sh3";
    if (isExpired && !showExpiredTimer) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            withTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: customTitleClassname ?? titleClassname,
                message: messages.title,
                style: customTitleStyle ?? titleStyle,
                color: customTitleColor ?? titleColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("inline-flex items-baseline text-center", textStyle),
                ref: countdownRef,
                dangerouslySetInnerHTML: {
                    __html: countdownMessage
                },
                "data-testid": dataTestId
            })
        ]
    });
};
/* harmony default export */ const StyledTimer_StyledTimer = (/*#__PURE__*/react.memo(StyledTimer));


/***/ }),

/***/ 71498:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SubscribeWithTimerStickyBar_SubscribeWithTimerStickyBar)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useStickyBeforeFooter.ts
var useStickyBeforeFooter = __webpack_require__(29555);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(7138);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/components/layout/StickyFooterContainer/StickyFooterContainer.tsx + 1 modules
var StickyFooterContainer = __webpack_require__(53046);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/compositions/StyledTimer/StyledTimer.tsx + 1 modules
var StyledTimer = __webpack_require__(93735);
;// CONCATENATED MODULE: ./src/compositions/SubscribeWithTimerStickyBar/messages.ts
/* harmony default export */ const SubscribeWithTimerStickyBar_messages = ({
    limitedTime: {
        en: "Limited time offer:"
    },
    noOffer: {
        en: "Discover new scents every month from over 700 authentic, luxury fragrances."
    },
    discount: {
        en: 'Get {discount} off<span class="onlyDesktop"> and a free case in</span>&nbsp;your&nbsp;first&nbsp;month'
    },
    freeTrial: {
        en: "Get your free perfume now,<br />just pay for shipping and handling"
    },
    freeProduct: {
        en: "Get a free product in your first order"
    },
    freeMonth: {
        en: "Get your second month for free"
    }
});

;// CONCATENATED MODULE: ./src/compositions/SubscribeWithTimerStickyBar/SubscribeWithTimerStickyBar.tsx













const messagesByOffer = {
    freeTrial: SubscribeWithTimerStickyBar_messages.freeTrial,
    free2ndMonth: SubscribeWithTimerStickyBar_messages.freeMonth,
    freeProduct: SubscribeWithTimerStickyBar_messages.freeProduct,
    discount: SubscribeWithTimerStickyBar_messages.discount
};
const SubscribeWithTimerStickyBar = (props)=>{
    const { buttonProps, containerSize = 944, position = "top", isReverseMobile, minimalScrollOffset, triggerRef, onClick } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const isVisible = (0,useStickyBeforeFooter/* default */.Z)({
        triggerRef,
        minimalScrollOffset
    });
    const { formattedPrice: price, formattedPriceWithDiscount, formattedExtraShippingPrice, discountText: discount, eventDiscountText, couponCode, offerType, isFetching, handleSubscribeClick } = (0,subscribe/* useSubscribeOffer */.Hu)();
    const priceWithDiscount = offerType === "freeTrial" ? formattedExtraShippingPrice : formattedPriceWithDiscount;
    const handleClick = (0,react.useCallback)(()=>{
        (0,analytics/* track */.j)("Banner click", {
            placement: "Sticky bar",
            content: "Subscribe",
            action: "link",
            link: links/* default */.ZP.subscribe,
            discount: eventDiscountText,
            coupon: couponCode
        });
        handleSubscribeClick();
        if (typeof onClick === "function") {
            onClick();
        }
    }, [
        eventDiscountText,
        couponCode,
        handleSubscribeClick,
        onClick
    ]);
    const { text, buttonTitle } = (0,react.useMemo)(()=>{
        if (isFetching) {
            return {};
        }
        const text = offerType ? {
            ...messagesByOffer[offerType],
            values: {
                discount
            }
        } : SubscribeWithTimerStickyBar_messages.noOffer;
        const shouldShowPriceWithDiscount = Boolean(priceWithDiscount && priceWithDiscount !== price && (offerType === "freeTrial" || offerType === "discount"));
        let buttonTitle = buttonProps?.title;
        if (!buttonTitle) {
            const buttonTitleBase = shouldShowPriceWithDiscount ? messages/* default */.Z.subscribeForPriceWithDiscount : messages/* default */.Z.subscribeForPrice;
            buttonTitle = {
                ...buttonTitleBase,
                values: {
                    price,
                    priceWithDiscount
                }
            };
        }
        return {
            text,
            buttonTitle
        };
    }, [
        buttonProps?.title,
        isFetching,
        discount,
        offerType,
        price,
        priceWithDiscount
    ]);
    if (isFetching) {
        return null;
    }
    const textStyle = isMobile ? "p4" : offerType ? "sh4" : "p2";
    const mobileContainerClassName = isReverseMobile ? "pb-16 flex flex-col" : "pt-16";
    const mobileButtonClassName = isReverseMobile ? "order-2" : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyFooterContainer/* default */.Z, {
        bgColor: "bg-gold-30",
        position: position,
        isVisible: isVisible,
        "data-testid": "stickyFooter",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: isMobile ? mobileContainerClassName : "flex items-center justify-between",
            size: containerSize,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: (0,clsx/* default */.Z)(buttonProps?.className, isMobile ? mobileButtonClassName : "order-2 my-24 ml-32"),
                    title: buttonTitle,
                    to: links/* default */.ZP.subscribe,
                    size: 56,
                    width: 280,
                    fullWidthOnMobile: true,
                    rightIcon: buttonProps?.rightIcon,
                    inlineIcon: buttonProps?.inlineIcon,
                    html: true,
                    onClick: handleClick,
                    "data-testid": "subscribeButton"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-1 items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-16",
                            children: [
                                isMobile && offerType !== "freeTrial" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    message: SubscribeWithTimerStickyBar_messages.limitedTime,
                                    style: isMobile ? "p4" : "sh4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    message: text,
                                    style: textStyle,
                                    tag: isMobile ? "b" : "span",
                                    html: true
                                })
                            ]
                        }),
                        Boolean(offerType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimer/* default */.Z, {
                            className: isMobile ? "ml-16 mt-8" : "ml-20 mt-12",
                            size: isMobile ? 36 : 56,
                            "data-testid": "timer"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const SubscribeWithTimerStickyBar_SubscribeWithTimerStickyBar = (SubscribeWithTimerStickyBar);


/***/ }),

/***/ 53197:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31978);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66226);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16776);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23796);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21182);






const ResubscribeButton = (props)=>{
    const { className, size = 56, style = "primary", width, fullWidth, fullWidthOnMobile, productToAdd, title, loading, placement, onProductAdded, "data-testid": dataTestId = "resubscribeButton" } = props;
    const { eventOffer } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useResubscribeOffer */ .W)();
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        (0,analytics__WEBPACK_IMPORTED_MODULE_3__/* .track */ .j)("Banner click", {
            placement,
            content: "Resubscribe",
            offer: eventOffer
        });
        (0,modals__WEBPACK_IMPORTED_MODULE_4__/* .openModal */ .h7)("resubscribeModal", {
            productToAdd,
            onProductAdded
        });
    }, [
        placement,
        eventOffer,
        productToAdd,
        onProductAdded
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: className,
        title: title || components_inputs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.resubscribeNow,
        size: size,
        style: style,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        "data-testid": dataTestId,
        onClick: handleClick,
        loading: loading,
        html: true
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ResubscribeButton));


/***/ }),

/***/ 55095:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ util_useNextProducts)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/date/index.ts
var date = __webpack_require__(64895);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/modules/products/fom/index.ts + 1 modules
var fom = __webpack_require__(63348);
// EXTERNAL MODULE: ./src/modules/queue/index.ts + 7 modules
var modules_queue = __webpack_require__(11982);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
;// CONCATENATED MODULE: ./src/compositions/modals/ResubscribeModal/util/messages.ts
/* harmony default export */ const messages = ({
    giftSubscriptionOffer: {
        en: "One free fragrance in your Scentbird subscription"
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/ResubscribeModal/util/useNextProducts.ts









const giftSubscriptionOfferProduct = {
    free: true,
    name: messages.giftSubscriptionOffer
};
const useNextProducts = (param)=>{
    let { freeProduct, giftSubscriptionOffer, productToAdd } = param;
    const isGiftSubscriptionOfferEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftSubscriptionOffer);
    const { gender } = (0,user/* useUser */.aF)();
    const withGiftSubscriptionOffer = isGiftSubscriptionOfferEnabled && giftSubscriptionOffer > 0;
    const { items: queue, isFetching: isQueueFetching } = (0,modules_queue/* useQueue */.Ln)();
    const { currentFOM, isFetching: isFOMFetching } = (0,fom/* useCurrentFOM */.R_)({
        gender,
        skip: Boolean(productToAdd) || withGiftSubscriptionOffer
    });
    const isNextProductsFetching = isFOMFetching || isQueueFetching;
    const queueProducts = (0,react.useMemo)(()=>{
        if (isNextProductsFetching) {
            return [
                {
                    month: "",
                    nextMonth: "",
                    products: []
                }
            ];
        }
        let queueItems = queue;
        if (queueItems && withGiftSubscriptionOffer) {
            queueItems = queueItems.filter((item)=>{
                const { stateOptions } = item;
                const { isLocked, isShipped } = stateOptions;
                return !isLocked && !isShipped;
            });
        }
        return (queueItems || []).slice(0, giftSubscriptionOffer || 1).map((item, index)=>{
            const { month, products: monthProducts } = item;
            const isFirstMonth = index === 0;
            let products = [];
            if (productToAdd && isFirstMonth) {
                products.push(productToAdd.product);
            } else {
                products = monthProducts.map((param)=>{
                    let { tradingItem } = param;
                    if (tradingItem?.productInfo) {
                        const { image, name, brandInfo: { name: brand }, upchargePrice } = tradingItem.productInfo;
                        return {
                            name,
                            image,
                            brand,
                            label: null,
                            free: withGiftSubscriptionOffer,
                            upchargePrice
                        };
                    }
                    return null;
                }).filter(Boolean);
            }
            if (currentFOM && !products.length && isFirstMonth) {
                const { image, name, brand } = currentFOM;
                products.push({
                    image,
                    name,
                    brand,
                    label: "fom"
                });
            }
            if (withGiftSubscriptionOffer && !products.length) {
                products.push(giftSubscriptionOfferProduct);
            }
            if (freeProduct && isFirstMonth) {
                const { image, name, brandInfo } = freeProduct;
                products.push({
                    image,
                    name,
                    brand: brandInfo?.name,
                    label: "freeProduct"
                });
            }
            const months = date/* default */.ZP.months();
            const monthNumber = month - 1;
            const nextMonthNumber = (monthNumber + 1) % months.length;
            return {
                month: months[monthNumber],
                nextMonth: months[nextMonthNumber],
                products
            };
        });
    }, [
        currentFOM,
        freeProduct,
        isNextProductsFetching,
        productToAdd,
        queue,
        withGiftSubscriptionOffer,
        giftSubscriptionOffer
    ]);
    if (withGiftSubscriptionOffer && queueProducts.length < giftSubscriptionOffer) {
        const nextMonth = queueProducts[0]?.nextMonth;
        if (nextMonth) {
            queueProducts.push({
                month: nextMonth,
                nextMonth: "",
                products: [
                    giftSubscriptionOfferProduct
                ]
            });
        }
    }
    return {
        queueProducts,
        isNextProductsFetching: isFOMFetching || isQueueFetching,
        withGiftSubscriptionOffer
    };
};
/* harmony default export */ const util_useNextProducts = (useNextProducts);


/***/ }),

/***/ 3985:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ FragranceCatalogPage_FragranceCatalogPage)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
// EXTERNAL MODULE: ./src/modules/limitedDrops/useLimitedDropSale.ts + 1 modules
var useLimitedDropSale = __webpack_require__(78721);
// EXTERNAL MODULE: ./src/components/layout/PageLayout/PageLayout.tsx
var PageLayout = __webpack_require__(89902);
// EXTERNAL MODULE: ./src/compositions/banners/LimitedDropsBanner/LimitedDropsBanner.tsx + 6 modules
var LimitedDropsBanner = __webpack_require__(29152);
// EXTERNAL MODULE: ./src/compositions/banners/ResubscribeBanner/ResubscribeBanner.tsx + 1 modules
var ResubscribeBanner = __webpack_require__(53583);
// EXTERNAL MODULE: ./src/pages/catalog/components/CatalogContextProvider/CatalogContextProvider.tsx + 8 modules
var CatalogContextProvider = __webpack_require__(65714);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/modules/collaborations/useCollaboration.ts
var useCollaboration = __webpack_require__(47669);
// EXTERNAL MODULE: ./src/compositions/ScentbirdSelectBlock/ScentbirdSelectBlock.tsx + 10 modules
var ScentbirdSelectBlock = __webpack_require__(50346);
;// CONCATENATED MODULE: ./src/pages/catalog/components/CollaborationBanner/CollaborationBanner.tsx





const COLLABORATIONS_BANNERS = {
    saks: ScentbirdSelectBlock/* default */.Z
};
const CollaborationBanner = ()=>{
    const [{ collaboration: collaborationSearchParam }] = (0,contexts/* useSearchParams */.lr)();
    const collaboration = (0,useCollaboration/* default */.Z)();
    const Banner = COLLABORATIONS_BANNERS[collaboration];
    if (!Banner || collaboration === collaborationSearchParam) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
        className: "my-40"
    });
};
/* harmony default export */ const CollaborationBanner_CollaborationBanner = (CollaborationBanner);

// EXTERNAL MODULE: ./src/pages/catalog/components/ProductFeed/ProductFeed.tsx + 1 modules
var ProductFeed = __webpack_require__(50824);
// EXTERNAL MODULE: ./src/pages/catalog/components/UpgradeFeedBanner/UpgradeFeedBanner.tsx
var UpgradeFeedBanner = __webpack_require__(8859);
// EXTERNAL MODULE: ./src/pages/catalog/util/useFragranceCatalogueName.ts
var useFragranceCatalogueName = __webpack_require__(31776);
// EXTERNAL MODULE: ./src/pages/catalog/components/FragranceTabsHeader/FragranceTabsHeader.tsx + 2 modules
var FragranceTabsHeader = __webpack_require__(13985);
// EXTERNAL MODULE: ./src/pages/catalog/components/ActivePersonalityTags/ActivePersonalityTags.tsx
var ActivePersonalityTags = __webpack_require__(41392);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(17696);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/components/dataDisplay/BackgroundImage/BackgroundImage.tsx + 1 modules
var BackgroundImage = __webpack_require__(26713);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
;// CONCATENATED MODULE: ./src/pages/catalog/components/BundlingBanner/images/detailed.jpg
const detailed_namespaceObject = __webpack_require__.p + "images/detailed_5fa31b.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/components/BundlingBanner/images/small.jpg
const small_namespaceObject = __webpack_require__.p + "images/small_c6ca7a.jpg";
;// CONCATENATED MODULE: ./src/pages/catalog/components/BundlingBanner/messages.ts
/* harmony default export */ const BundlingBanner_messages = ({
    supTitle: {
        en: "Buy any 4 travel-size fragrances"
    },
    title: {
        en: "Get the 5th <br /> for free"
    },
    label: {
        en: "Get 5th for free"
    },
    smallLabel: {
        en: "5th for free"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/components/BundlingBanner/BundlingBanner.tsx













const BundlingBanner = (props)=>{
    const { className, type } = props;
    const { gender } = (0,user/* useUser */.aF)();
    const link = gender === "FEMALE" ? links/* default */.ZP.shop.travelSize.perfumes : links/* default */.ZP.shop.travelSize.colognes;
    const isSmall = type === "small";
    const handleClick = ()=>{
        (0,analytics/* track */.j)("Banner click", {
            content: "Get the 5th free",
            action: "link",
            link,
            placement: "Page body"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Href/* default */.Z, {
        className: (0,clsx/* default */.Z)("relative block min-h-[368rem] bg-light-beige py-24 text-center", isSmall ? "px-12 " : "px-16", className),
        to: link,
        onClick: handleClick,
        "data-testid": "bundlingBanner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
                className: "absolute inset-0 bg-cover",
                src: isSmall ? small_namespaceObject : detailed_namespaceObject
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: isSmall ? "h9" : "h8",
                        color: "white",
                        message: BundlingBanner_messages.supTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: isSmall ? "mt-4" : "mt-8",
                        style: isSmall ? "h6" : "h4",
                        message: BundlingBanner_messages.title,
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: isSmall ? "mt-8" : "mt-16",
                        size: isSmall ? 38 : 48,
                        fullWidth: true,
                        style: "primary",
                        title: messages/* default */.Z.shopNow
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx/* default */.Z)("absolute right-0 top-full flex items-center justify-center rounded-full bg-black px-12 font-tt-norms-pro font-bold uppercase text-white", isSmall ? "-mr-6 mt-12 h-s48 w-s48 text-[7rem]/[7rem]" : "mt-20 h-[88rem] w-[88rem] text-[11rem]/[12rem]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                            value: isSmall ? BundlingBanner_messages.smallLabel : BundlingBanner_messages.label
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const BundlingBanner_BundlingBanner = (/*#__PURE__*/(0,react.memo)(BundlingBanner));

// EXTERNAL MODULE: ./src/compositions/SubscribeWithTimerStickyBar/SubscribeWithTimerStickyBar.tsx + 1 modules
var SubscribeWithTimerStickyBar = __webpack_require__(71498);
// EXTERNAL MODULE: ./src/compositions/ResubscribeWithTimerStickyBar/ResubscribeWithTimerStickyBar.tsx + 1 modules
var ResubscribeWithTimerStickyBar = __webpack_require__(33297);
;// CONCATENATED MODULE: ./src/pages/catalog/FragranceCatalogPage/components/StickyFooter/StickyFooter.tsx






const StickyFooter = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const hasNeverSubscribed = subscription?.hasNeverSubscribed;
    const isCancelled = subscription?.isCancelled;
    if (isCancelled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResubscribeWithTimerStickyBar/* default */.Z, {
            minimalScrollOffset: isMobile ? 100 : 300,
            isReverseMobile: true,
            position: isMobile ? "bottom" : "top"
        });
    }
    if (!hasNeverSubscribed) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeWithTimerStickyBar/* default */.Z, {
        minimalScrollOffset: isMobile ? 0 : 300,
        isReverseMobile: true,
        position: isMobile ? "bottom" : "top"
    });
};
/* harmony default export */ const StickyFooter_StickyFooter = (StickyFooter);

;// CONCATENATED MODULE: ./src/pages/catalog/FragranceCatalogPage/messages.ts
/* harmony default export */ const FragranceCatalogPage_messages = ({
    browse: {
        en: "Browse"
    },
    allFragrances: {
        en: "All fragrances"
    }
});

;// CONCATENATED MODULE: ./src/pages/catalog/FragranceCatalogPage/FragranceCatalogPage.tsx






















const FragranceCatalogPage = ()=>{
    const { catalogueName, isMale } = (0,useFragranceCatalogueName/* default */.Z)({
        colognesLink: links/* default */.ZP.subscription.colognes
    });
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const { data: limitedDropData } = (0,useLimitedDropSale/* default */.Z)();
    const isUpgradeBannerVisible = subscription?.isUpgradableFromMonthlyPlan;
    const isResubscribeBannerVisible = subscription?.isCancelled;
    const isBuy5pay4BannerVisible = (0,useFt/* default */.Z)(constants/* default */.Z.features.buy5pay4);
    (0,react.useEffect)(()=>{
        (0,analytics/* track */.j)("Fragrance page");
    }, [
        catalogueName
    ]);
    // ATTN keys are required
    const injectBanners = [
        limitedDropData?.enabled && {
            node: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitedDropsBanner/* default */.Z, {
                className: "my-40",
                size: "cut-width",
                placement: "Page body"
            }, "limitedDrop"),
            index: isMobile ? 2 : 3
        },
        isUpgradeBannerVisible && {
            node: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpgradeFeedBanner/* default */.Z, {}, "upgradeBanner"),
            index: 6
        },
        {
            node: isResubscribeBannerVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResubscribeBanner/* default */.Z, {
                className: isMobile ? "my-40" : "my-80"
            }, "resubscribeBanner") : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollaborationBanner_CollaborationBanner, {}, "collaborationBanner"),
            index: isUpgradeBannerVisible ? 12 : 6
        }
    ].filter(Boolean);
    // these banners will be injected right into the feed itself replacing product cards
    const injectFeedBanners = isBuy5pay4BannerVisible ? [
        {
            node: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlingBanner_BundlingBanner, {
                type: isMobile ? "small" : "detailed"
            }, "bundlingBanner"),
            index: isMobile ? 2 : 3
        }
    ] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CatalogContextProvider/* default */.Z, {
        catalogueName: catalogueName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLayout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FragranceTabsHeader/* default */.Z, {
                        mobileTitle: FragranceCatalogPage_messages.allFragrances,
                        desktopTitlePrefix: FragranceCatalogPage_messages.browse,
                        perfumesLink: links/* default */.ZP.subscription.perfumes,
                        colognesLink: links/* default */.ZP.subscription.colognes
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivePersonalityTags/* default */.Z, {
                        catalogueName: catalogueName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFeed/* default */.Z, {
                        withFilters: true,
                        isFragrance: true,
                        isMale: isMale,
                        injectBanners: injectBanners,
                        injectFeedBanners: injectFeedBanners,
                        hideWithoutTradingItems: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyFooter_StickyFooter, {})
        ]
    });
};
/* harmony default export */ const FragranceCatalogPage_FragranceCatalogPage = (FragranceCatalogPage);


/***/ })

}]);